<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-contact  has-aside-base">
            <Historico :nmComponente="'ParecerParametrizado'" :reload="reload" :seleciona="seleciona" :novo="novo" :id="idParecerParametrizado"></Historico>

            <div class="tyn-main tyn-content-inner" id="tynMain">
                <ul class="tyn-list-inline d-md-none translate-middle-x position-absolute start-50 z-1">
                    <li>
                        <button class="btn btn-icon btn-pill btn-white js-toggle-main" @click="fechar">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg><!-- x-lg -->
                        </button>
                    </li>
                </ul>
                <div class="tyn-chat-body m-4 rounded-3" data-simplebar>
                    <div class="container px-0">
                        <template v-if="idParecerParametrizado == 0">
                            <div class="tyn-qa tyn-qa-bubbly">
                                <!-- NOVO -->

                                <template v-if="flRealizaParecerParametrizado">
                                    <!-- nao pode realizar novo -->
                                    <template v-if="!(utilizacoes && utilizacoes.permiteRealizarParecerParametrizado) && flVerificouUtilizacoes">
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p>
                                                    Desculpe, parece que você atingiu seu limite de Pareceres Parametrizados do contrato.
                                                    Entre em contato com um dos nossos consultores.
                                                </p>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- ETAPA 1 - LEGISLACAO -->
                                    <template>
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p><span class="fw-bold">Escolha a legislação:</span> (Baseado em qual lei deseja a resposta). </p>
                                                <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstLegislacao" :key="index">
                                                    <input type="radio" :id="'legislacao-'+item.idLegislacao" name="idLegislacao" v-model="idLegislacao" :value="item.idLegislacao" />
                                                    <label class="ps-2" :for="'legislacao-'+item.idLegislacao">
                                                        {{item.dsNome}} {{(item.dsLegislacao && item.dsLegislacao != ""? "- "+item.dsLegislacao : "")}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 0">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(0)" v-if="utilizacoes && utilizacoes.permiteRealizarParecerParametrizado">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- ETAPA 2 - MODELO -->
                                    <template v-if="etapa > 0 && lstModelos.length > 1">
                                        <div class="tyn-qa-item" ref="etapaModelo">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p><span class="fw-bold">Escolha o modelo:</span> Selecione o modelo de parecer parametrizado.</p>
                                                <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstModelos" :key="index">
                                                    <input type="radio" :id="'modelo-'+item.idModeloArtefato" name="idModeloArtefato" v-model="idModeloArtefato" :value="item.idModeloArtefato" />
                                                    <label class="ps-2" :for="'modelo-'+item.idModeloArtefato">
                                                        {{item.nmModelo}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 1">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(1)" v-if="utilizacoes && utilizacoes.permiteRealizarParecerParametrizado">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- ETAPA 3 - ARQUIVOS -->
                                    <template v-if="etapa > 1">
                                        <div class="tyn-qa-item" ref="etapa1">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p class="fw-bold mb-2">
                                                    Envie os arquivos para o parecer parametrizado
                                                </p>
                                                <p class="mb-0">Envie aqui as informações que você já possui sobre a contratação </p>
                                                <p>(Exemplo: descrição do objeto ou serviço; um processo anterior já realizado; pesquisa de preços; etc)</p>

                                                <AvisoUploadDocumentos />

                                                <ImputUploadS3 :reset="resetUpload" :labelText="'Selecionar Arquivos'" @onSave="setUploadFile" @onDelete="deleteUploadFile" :destino="'ParecerParametrizado'" :id="'input_file_parecer_parametrizado'" :multiple="true" :maxFiles="5" :whoFiles="'.pdf,.doc,.docx,.txt'"></ImputUploadS3>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 2">
                                            <div class="col text-end" v-if="utilizacoes && utilizacoes.permiteRealizarParecerParametrizado">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(2)">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- ETAPA 4 - NORMATIVAS -->
                                    <template v-if="etapa > 2">
                                        <div class="tyn-qa-item" ref="etapa2">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p class="fw-bold mb-2">
                                                    Deseja utilizar alguma normativa:
                                                </p>
                                                <template v-if="lstNormas && lstNormas.length > 0">
                                                    <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstNormas" v-bind:key="index">
                                                        <input type="checkbox" :id="'normaParecerParametrizado'+ index" :value="item.idNorma" v-model="lstIdNorma" :disabled="disabled" />
                                                        <label class="ps-2" :for="'normaParecerParametrizado'+index">
                                                            {{item.dsNome}}
                                                        </label>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <span>Nenhuma normativa cadastrada. Você pode enviar sem selecionar normativas.</span>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 3">
                                            <div class="col text-end" v-if="utilizacoes && utilizacoes.permiteRealizarParecerParametrizado">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(3)">Enviar</button>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                                <template v-else-if="flVerificouRealizar">
                                    <div class="tyn-qa-item">
                                        <div class="tyn-qa-avatar">
                                            <div class="tyn-qa-avatar-wrap">
                                                <div class="tyn-media tyn-size-md" style="background: transparent">
                                                    <img src="assets/images/sollai/avatar.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tyn-qa-message tyn-text-block bg-response">
                                            <p>
                                                Aguarde a conclusão do parecer parametrizado atual antes de realizar um novo.
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </div>

                        </template>
                        <template v-else>
                            <!-- RESULTADO -->
                            <div class="tyn-qa tyn-qa-bubbly">
                                <div class="tyn-qa-item" v-if="parecerParametrizado">
                                    <div class="tyn-qa-avatar">
                                        <div class="tyn-qa-avatar-wrap">
                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                <template v-if="user.usuarioApi">
                                                    <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                                    <img v-else src="assets/images/avatar/3.jpg" alt="">
                                                </template>
                                                <template v-else>
                                                    <img src="assets/images/avatar/3.jpg" alt="">
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                        <p class="mb-0" v-if="parecerParametrizado.dsNome">
                                            <strong>{{parecerParametrizado.dsNome}}</strong>
                                        </p>
                                        <template v-if="parecerParametrizado.usuario">
                                            <p class="mb-0" v-if="user.usuario.dsLogin != parecerParametrizado.usuario.dsLogin">
                                                <strong>Usuário: </strong>{{parecerParametrizado.usuario.nmUsuario}}
                                            </p>
                                        </template>
                                        <p class="mb-0" v-if="parecerParametrizado.lstFonteDados && parecerParametrizado.lstFonteDados.length > 0">
                                            <strong>Fonte de dados: </strong>
                                            <a class="c-pointer item-fonte ms-2" href="javascript:void(0)" @click="downloadDocumento(item,false)" :key="index" v-for="(item,index) in parecerParametrizado.lstFonteDados">{{getNomeArquivo(item.urlArquivo)}}</a>
                                        </p>
                                        <p class="mb-0" v-if="legislacao">
                                            <strong>Legislação: </strong>
                                            <a href="javascript:void(0)" @click="openReferencia(legislacao.tpConteudo, legislacao.idConteudo)">
                                                {{legislacao.dsNome}}
                                            </a>
                                        </p>
                                        <p class="mb-0" v-if="nmModelo">
                                            <strong>Modelo: </strong>{{nmModelo}}
                                        </p>
                                        <p class="mb-0" v-if="lstNormasSelecionadas && lstNormasSelecionadas.length > 0">
                                            <strong>Normativas: </strong>
                                            <span v-for="(item, index) in lstNormasSelecionadas" :key="item.idNorma || index">
                                                <a href="javascript:void(0)" @click="downloadNormativa(item.urlArquivo, item.dsNome)">
                                                    {{item.dsNome}}
                                                </a><span v-if="index < lstNormasSelecionadas.length - 1">, </span>
                                            </span>
                                        </p>
                                        <p class="mb-0">
                                            <strong>Data da solicitação: </strong>{{parecerParametrizado.dtInclusao}}
                                        </p>
                                    </div>
                                </div>
                                <div class="tyn-qa-item">
                                    <div class="tyn-qa-avatar">
                                        <div class="tyn-qa-avatar-wrap">
                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                <img src="assets/images/sollai/avatar.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                        <template v-if="statusParecerParametrizado == 'Processando' || statusParecerParametrizado == 'Iniciada'">
                                            <p class="fw-bold mb-2">
                                                {{mensagemProcessando}}
                                            </p>
                                            <p class="mb-2">
                                                Por favor, aguarde um momento enquanto eu processo seu parecer parametrizado. Obrigado pela sua paciência e compreensão.
                                            </p>
                                            <div class="progress px-0 d-none">
                                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: '20%'}"></div>
                                            </div>

                                        </template>
                                        <template v-if="statusParecerParametrizado == 'Cancelada'">
                                            <span class="text-danger fs-1">
                                                <i class="fas fa-exclamation-triangle text-danger fs-1"></i>
                                            </span>
                                            <p class="fw-bold mb-2">
                                                Erro ao processar o parecer parametrizado
                                            </p>
                                            <p class="mb-2">
                                                {{msgErro}}
                                            </p>
                                        </template>
                                        <template v-if="statusParecerParametrizado == 'Finalizada'">
                                            <template v-if="parecerParametrizado">
                                                <p class="mb-20">Seu documento esta pronto!</p>
                                                <p>Faça o download do arquivo.</p>

                                                <div class="row justify-content-end" v-if="parecerParametrizado.resposta">
                                                    <div class="col text-end">
                                                        <button class="btn btn-outline-primary" @click="downloadDocumento(parecerParametrizado.resposta, true)" v-if="parecerParametrizado.resposta && (parecerParametrizado.resposta.urlArquivo || parecerParametrizado.resposta.fileId)">
                                                            <span class="ms-0">Fazer Download</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-3">
                                <button class="btn btn-outline-primary" @click="novo">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                    </svg> Criar novo parecer parametrizado
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
                
            </div>
        </div>

        <!-- MODAIS HEADER -->
        <Modais></Modais>

        <ModalDetalhes :dados="modalDetalhes" :showModal="showModalDetalhes"></ModalDetalhes>
    </div>
</template>
<script>
    import Header from '@/components/Header'
    import Historico from '@/components/Historico'
    import Modais from '@/components/Modais'
    import ModalDetalhes from '@/components/ModalDetalhes'
    import ImputUploadS3 from '@/components/Input_Upload_s3'
    import AvisoUploadDocumentos from '@/components/AvisoUploadDocumentos'

    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'ParecerParametrizado',
        components: { Header, Historico, ModalDetalhes, ImputUploadS3, AvisoUploadDocumentos, Modais },
        computed: {
            user() {
                return this.$store.state.user
            },
            hubConection() {
                return this.$store.state.hubConection
            },
            lstNormas() {
                return this.$store.state.lstNormas
            },
        },
        data: function () {
            return {
                reload: false,

                idParecerParametrizado: 0,
                idLegislacao: null,
                idModeloArtefato: null,
                lstModelos: [],
                lstIdNorma: [],
                files: null,
                etapa: 0,
                msgErro: null,
                flReprocessar: false,
                disabled: false,
                statusParecerParametrizado: null,
                parecerParametrizado: null,

                flRealizaParecerParametrizado: false,
                utilizacoes: null,
                flVerificouUtilizacoes: false,
                mensagemProcessando: "Processando parecer parametrizado...",
                flVerificouRealizar: false,

                lstLegislacao: [],
                legislacao: null,
                nmModelo: null,
                lstNormasSelecionadas: [],

                modalDetalhes: {
                    cdConteudo: null,
                    idItemPesquisa: null,
                    dsReferencia: null,
                },

                showModalDetalhes: false,
                resetUpload: false,
            }
        },

        methods: {
            fechar() {
                document.getElementById('tynMain').classList.toggle('main-shown')
            },

            seleciona(id, tipo) {
                if (tipo == 4) {
                    this.idParecerParametrizado = id;
                    this.load();
                }
            },

            novo() {
                this.idParecerParametrizado = 0;
                this.etapa = 0;
                this.idLegislacao = null;
                this.idModeloArtefato = null;
                this.lstModelos = [];
                this.lstIdNorma = [];
                this.files = null;
                this.resetUpload = !this.resetUpload;
                this.flReprocessar = false;
                this.parecerParametrizado = null;
                this.statusParecerParametrizado = null;
                this.legislacao = null;
                this.nmModelo = null;
                this.lstNormasSelecionadas = [];
                this.disabled = false;

                this.load();
            },

            load() {
                if (this.idParecerParametrizado != 0) {
                    this.carregaParecerParametrizado();
                }

                this.carregaLegislacoes();
                this.verificaRealizaParecerParametrizado();
                this.carregaUtilizacoes();
            },

            carregaLegislacoes() {
                let $this = this;
                $this.lstLegislacao = [];
                axios.get(`${urlApi}/Legislacao/GetLegislacaoParecerParametrizado`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstLegislacao = res.data.data;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            InitSignalR() {
                try {
                    let $this = this;
                    //var token = $this.user.accessToken;
                    //var connection = new window.signalR.HubConnectionBuilder().withUrl(`${urlSignal}notificacaohub?p_dsLogin=` + $this.user.usuario.dsLogin, { accessTokenFactory: () => token }).build();

                    $this.hubConection.on("RecebeNotificacaoParecerParametrizado", function (idParecerParametrizado, status, dtAtualizacao) {
                        if ($this.idParecerParametrizado == idParecerParametrizado) {
                            $this.load();
                        } else {
                            avisoToast('Status do parecer parametrizado atualizado para ' + status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                        }
                    });

                    $this.hubConection.on("AtualizaRealizarParecerParametrizado", function (flRealizaParecerParametrizado) {
                        $this.flRealizaParecerParametrizado = flRealizaParecerParametrizado == "Sim" || flRealizaParecerParametrizado == "true" ? true : false;
                    });

                    $this.hubConection.on("AtualizaStatusParecerParametrizado", function (idParecerParametrizado, status,) {
                        $this.mensagemProcessando = status;
                    });

                    //$this.hubConection.start().then(function () {
                    //    console.log('Connetado!');
                    //}).catch(function (err) {
                    //    return console.error('Erro: ', err.toString());
                    //});

                    ////$this.hubConection.disconnected(function () {
                    ////    setTimeout(function () {
                    ////        console.log('Tentando Reconectar!');
                    ////        $this.hubConection.hub.start();
                    ////    }, 5000);
                    ////});
                    //$this.hubConection.onclose(async () => {
                    //    setTimeout(function () {
                    //        console.log('Tentando Reconectar!');
                    //        $this.hubConection.hub.start();
                    //    }, 5000);
                    //});
                }
                catch (ex) {
                    console.log(ex);
                }
            },

            proximo(p_etapa) {
                switch (p_etapa) {
                    case 0:
                        if (this.idLegislacao) {
                            this.carregaModelosLegislacao();
                        } else {
                            avisoToast("Selecione uma legislação", "warning");
                        }
                        break;

                    case 1:
                        if (this.idModeloArtefato) {
                            this.etapa = 2;
                            this.rolarPara('etapa1');
                        } else {
                            avisoToast("Selecione um modelo", "warning");
                        }
                        break;

                    case 2:
                        if (this.files != null && this.files.length > 0) {
                            this.etapa = 3;
                            this.rolarPara('etapa2');
                        } else {
                            avisoToast("Selecione um arquivo", "warning");
                        }
                        break;

                    case 3:
                        if (this.utilizacoes && this.utilizacoes.permiteRealizarParecerParametrizado) {
                            this.enviarParecerParametrizado();
                        } else {
                            avisoToast("Desculpe, parece que você atingiu seu limite de Pareceres Parametrizados do contrato. Entre em contato com um dos nossos consultores.", "warning");
                        }
                        break;

                    default:
                        break;
                }
            },

            rolarPara(refName) {
                this.$nextTick(function () {
                    const el = this.$refs[refName];
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                });
            },

            carregaModelosLegislacao() {
                let $this = this;
                const idLegislacao = $this.idLegislacao;
                $this.lstModelos = [];
                $this.idModeloArtefato = null;

                axios.get(`${urlApi}/ParecerParametrizado/GetModelos`, { showLoading: true, params: { idLegislacao: idLegislacao } })
                    .then(res => {
                        if ($this.idLegislacao !== idLegislacao) {
                            return;
                        }

                        if (res.data.success) {
                            $this.lstModelos = res.data.data || [];
                            if ($this.lstModelos.length === 0) {
                                avisoToast("Nenhum modelo encontrado para a legislação selecionada.", "warning");
                                return;
                            }

                            if ($this.lstModelos.length === 1) {
                                $this.idModeloArtefato = $this.lstModelos[0].idModeloArtefato;
                                $this.etapa = 2;
                                $this.rolarPara('etapa1');
                                return;
                            }

                            $this.etapa = 1;
                            $this.rolarPara('etapaModelo');
                        } else {
                            avisoErro("Não foi possível carregar os modelos do parecer parametrizado.");
                        }
                    })
                    .catch(res => {
                        if (res.response && res.response.data) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os modelos do parecer parametrizado.");
                        }
                    });
            },

            enviarParecerParametrizado() {
                let $this = this;
                $this.statusParecerParametrizado = 'Processando';
                $this.disabled = true;

                const formData = new FormData();

                for (let i = 0; i < this.files.length; i++) {
                    formData.append("form.files", this.files[i].key);
                }

                formData.append("form.idLegislacao", $this.idLegislacao);
                formData.append("form.idModeloArtefato", $this.idModeloArtefato);

                if ($this.lstIdNorma != null && $this.lstIdNorma.length > 0) {
                    $this.lstIdNorma.forEach(function (idNorma) {
                        formData.append("form.idNormas", idNorma);
                    });
                }

                axios.post(`${urlApi}/ParecerParametrizado/Post`, formData)
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Parecer parametrizado registrado com sucesso, acompanhe a situação no campo status da listagem.");

                            $this.reload = !$this.reload;
                            $this.idParecerParametrizado = parseInt(res.data.data);
                            $this.load();
                        } else {
                            $this.flReprocessar = true;
                            $this.disabled = false;
                            avisoErro("Não foi possível enviar o parecer parametrizado.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.disabled = false;
                        $this.statusParecerParametrizado = 'Cancelada';
                        $this.msgErro = 'Não foi possível enviar o parecer parametrizado.';
                        if (res.response && res.response.data && res.response.data.errors) {
                            $this.msgErro = 'Não foi possível enviar o parecer parametrizado.' + " - " + res.response.data.errors[0];
                            avisoErro($this.msgErro);
                        } else {
                            avisoErro("Não foi possível enviar o parecer parametrizado.");
                        }
                    });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/ParecerParametrizado/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        $this.flVerificouUtilizacoes = true;
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de pareceres parametrizados.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de pareceres parametrizados.");
                        }
                    });
            },

            verificaRealizaParecerParametrizado() {
                let $this = this;
                axios.get(`${urlApi}/ParecerParametrizado/VerificaRealizarParecerParametrizado`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.flRealizaParecerParametrizado = res.data.data;
                            $this.flVerificouRealizar = true;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            carregaParecerParametrizado() {
                let $this = this;
                axios.get(`${urlApi}/ParecerParametrizado/Get/${$this.idParecerParametrizado}`)
                    .then(res => {
                        $this.parecerParametrizado = null;
                        if (res.data.success) {
                            var result = res.data.data;
                            var dados = result.parecerParametrizado;

                            var status = '';
                            if (result.lstParecerParametrizadoMovimento && result.lstParecerParametrizadoMovimento.length > 0) {
                                status = result.lstParecerParametrizadoMovimento[result.lstParecerParametrizadoMovimento.length - 1].dsMovimento;
                                $this.statusParecerParametrizado = status;
                            }

                            var lstFonteDados = [];
                            var resposta = null;
                            if (result.lstParecerParametrizadoDocumento && result.lstParecerParametrizadoDocumento.length > 0) {
                                lstFonteDados = result.lstParecerParametrizadoDocumento.filter(x => x.flResposta == false);
                                var lstResposta = result.lstParecerParametrizadoDocumento.filter(x => x.flResposta == true);
                                resposta = lstResposta && lstResposta.length > 0 ? lstResposta[0] : null;
                            }

                            $this.parecerParametrizado = {
                                idParecerParametrizado: dados.idParecerParametrizado,
                                dsLogin: dados.dsLogin,
                                dsNome: dados.dsNome,
                                dtInclusao: moment(dados.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                status: status,
                                usuario: result.usuario,
                                lstFonteDados: lstFonteDados,
                                resposta: resposta,
                                dsPrompt: dados.dsPrompt,
                            };

                            $this.legislacao = result.legislacao || null;
                            $this.nmModelo = result.nmModelo || null;
                            $this.lstNormasSelecionadas = result.lstNormas && result.lstNormas.length > 0 ? result.lstNormas : [];
                        } else {
                            avisoErro("Não foi possível carregar o parecer parametrizado.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                    });
            },

            downloadDocumento(item, flReplaceName) {
                axios({
                    url: `${urlApi}/ParecerParametrizado/DownloadDocumento/${item.idParecerParametrizadoDocumento}`,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    const nmArquivo = this.getNomeArquivo(item.urlArquivo || item.fileId, flReplaceName);
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo);
                    document.body.appendChild(link);
                    link.click();
                });
            },

            download(urlArquivo, flNome = false) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    if (flNome) {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    } else {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7);
                    }
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            getNomeArquivo(urlArquivo, flNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    if (flNome) {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    } else {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7);
                    }
                    return nmArquivo;
                } else {
                    return "daods";
                }
            },

            openReferencia(cdConteudo, idItemPesquisa, dsReferencia) {
                this.modalDetalhes = {
                    cdConteudo: cdConteudo,
                    idItemPesquisa: idItemPesquisa,
                    dsReferencia: dsReferencia,
                };
                this.showModalDetalhes = !this.showModalDetalhes;
            },

            setUploadFile(lstFiles) {
                if (lstFiles == null || lstFiles === '') {
                    return;
                }
                if (this.files == null) {
                    this.files = [];
                }
                const items = Array.isArray(lstFiles) ? lstFiles : [lstFiles];
                for (let i = 0; i < items.length; i++) {
                    if (!this.files.some(f => f.key === items[i].key)) {
                        this.files.push(items[i]);
                    }
                }
            },

            deleteUploadFile(hash) {
                if (!this.files) {
                    return;
                }
                this.files = this.files.filter(function (obj) { return obj.hash !== hash });
            },

            downloadNormativa(urlArquivo, dsNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo);
                    document.body.appendChild(link);
                    link.click();
                });
            },
        },
        mounted: function () {
            this.load();

            if (this.hubConection != undefined) {
                this.InitSignalR();
            }
        },
        watch: {
            idLegislacao: function () {
                this.lstIdNorma = [];
                this.idModeloArtefato = null;
                this.lstModelos = [];
                if (this.etapa > 0) {
                    this.etapa = 0;
                }
            },
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .tyn-qa-bubbly .tyn-qa-item:nth-child(even) .tyn-qa-message.bg-question, .tyn-qa-bubbly .tyn-qa-item:nth-child(odd) .tyn-qa-message.bg-question {
        background: var(--qa-bg-human);
    }

    .tyn-qa-bubbly .tyn-qa-item:nth-child(odd) .tyn-qa-message.bg-response, .tyn-qa-bubbly .tyn-qa-item:nth-child(even) .tyn-qa-message.bg-response {
        background: var(--qa-bg);
    }

    a {
        color: var(--bs-body-color);
    }

        a:hover, li:hover {
            text-decoration: underline;
            color: var(--bs-body-color);
        }

    .referencias {
        padding-left: 30px;
    }

        .referencias li {
            font-size: 14px;
        }

    .resposta {
        text-align: justify;
    }

    /* ========================================
       ESTILOS MODERNOS - PARECER PARAMETRIZADO
       ======================================== */
    
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.02);
        }
    }

    @keyframes shimmer {
        0% {
            background-position: -1000px 0;
        }
        100% {
            background-position: 1000px 0;
        }
    }

    /* Melhorias nas respostas da IA */
    .tyn-qa-message {
        transition: all 0.3s ease;
        
        &.bg-question {
            background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
            border-left: 4px solid #1f7bff;
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.15);
        }

        &.bg-response {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
            border-left: 4px solid #00d084;
            box-shadow: 0 2px 8px rgba(0, 208, 132, 0.15);
        }
    }

    /* Botões de opções modernos */
    .btn-outline-primary {
        border: 2px solid #1f7bff;
        color: #1f7bff;
        background: transparent;
        border-radius: 12px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            color: white;
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.3);
            transform: translateY(-2px);
        }

        &:active {
            transform: translateY(0);
        }
    }

    /* Progress bar moderna */
    .progress {
        height: 8px;
        border-radius: 10px;
        background: rgba(233, 236, 239, 0.5);
        overflow: hidden;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .progress-bar {
        border-radius: 10px;
        background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
        background-size: 200% 100%;
        animation: shimmer 2s linear infinite;
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.4);
    }

    /* Animações para mensagens de erro */
    .text-danger {
        animation: pulse 2s ease-in-out infinite;
    }

    /* Melhorias nos radio buttons */
    input[type="radio"] {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 1.25rem;
        height: 1.25rem;
        border: 2px solid #cbd5e0;
        border-radius: 50%;
        outline: none;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        background: white;
        flex-shrink: 0;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: white;
            transition: transform 0.2s ease;
        }

        &:checked {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);

            &::before {
                transform: translate(-50%, -50%) scale(1);
            }
        }

        &:hover:not(:disabled) {
            border-color: #1f7bff;
            transform: scale(1.1);
        }

        &:focus {
            outline: none;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background: #f1f3f5;
        }
    }

    input[type="checkbox"] {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 1.25rem;
        height: 1.25rem;
        border: 2px solid #cbd5e0;
        border-radius: 4px;
        outline: none;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        background: white;
        flex-shrink: 0;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            width: 8px;
            height: 8px;
            border-radius: 2px;
            background: white;
            transition: transform 0.2s ease;
        }

        &:checked {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);

            &::before {
                transform: translate(-50%, -50%) scale(1);
            }
        }

        &:hover:not(:disabled) {
            border-color: #1f7bff;
            transform: scale(1.1);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background: #f1f3f5;
        }
    }

    label {
        cursor: pointer;
        transition: color 0.3s ease;
        user-select: none;

        &:hover {
            color: #1f7bff;
        }
    }

    /* Títulos das seções */
    h5 {
        font-weight: 700;
        color: #2d3748;
        margin-bottom: 0.75rem;
        position: relative;
        padding-left: 1rem;
    }

    /* Links melhorados */
    .c-pointer {
        color: #1f7bff;
        text-decoration: none;
        transition: all 0.3s ease;
        font-weight: 500;

        &:hover {
            color: #00d084;
            text-decoration: underline;
        }
    }

    /* Popover customizado */
    :deep(.custom-popover) {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        border: 2px solid rgba(31, 123, 255, 0.2);

        .popover-header {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            color: white;
            border-radius: 10px 10px 0 0;
            font-weight: 600;
        }

        .popover-body {
            font-size: 0.9rem;
            line-height: 1.6;
        }
    }

    /* Área de upload melhorada */
    :deep(.input-group) {
        border-radius: 12px;
        overflow: hidden;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.15);
        }
    }

    :deep(.form-control) {
        border: 2px solid #e9ecef;
        border-radius: 12px;
        padding: 0.75rem 1rem;
        transition: all 0.3s ease;

        &:focus {
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1);
        }
    }

    :deep(.btn-primary) {
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        border: none;
        border-radius: 10px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);

        &:hover {
            background: linear-gradient(135deg, #0056d2 0%, #003d99 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.4);
        }

        &:active {
            transform: translateY(0);
        }
    }

    /* Ícones SVG */
    svg {
        transition: all 0.3s ease;
    }

    .bi-plus-lg {
        font-weight: bold;
    }

    /* Container de mensagens */
    .tyn-chat-body {
        animation: fadeInUp 0.5s ease-out;
    }

    /* Melhorias no container */
    .container {
        transition: all 0.3s ease;
    }

    /* Botão de novo parecer parametrizado */
    .btn-outline-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;

        svg {
            transition: transform 0.3s ease;
        }

        &:hover svg {
            transform: rotate(90deg) scale(1.1);
        }
    }

    /* Responsivo */
    @media (max-width: 768px) {
        .btn-outline-primary {
            width: 100%;
            justify-content: center;
            padding: 0.75rem 1.5rem;
        }

        h5 {
            font-size: 1rem;
        }

        input[type="radio"],
        input[type="checkbox"] {
            width: 1.1rem;
            height: 1.1rem;
        }
    }

    @media (max-width: 576px) {
        .btn-outline-primary {
            font-size: 0.9rem;
            padding: 0.7rem 1.25rem;
        }

        .tyn-qa-message {
            padding: 1rem;
        }

        h5 {
            font-size: 0.95rem;
            padding-left: 0.75rem;

            &::before {
                width: 3px;
            }
        }
    }

    /* ============================================
       DARK THEME - Parecer Parametrizado
       ============================================ */

    [data-bs-theme="dark"] .tyn-qa-message.bg-question {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%) !important;
        border-left-color: #60a5fa;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
        color: #e0f2fe;
    }

    [data-bs-theme="dark"] .tyn-qa-message.bg-response {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%) !important;
        border-left-color: #34d399;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
        color: #d1fae5;
    }

    [data-bs-theme="dark"] .btn-outline-primary {
        border-color: #3b82f6;
        color: #60a5fa;
        background: transparent;

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            color: white;
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
        }
    }

    [data-bs-theme="dark"] .progress {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .progress-bar {
        background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] input[type="radio"],
    [data-bs-theme="dark"] input[type="checkbox"] {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.2);

        &:checked {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            border-color: #3b82f6;
        }

        &:disabled {
            background: #1a1d29;
        }
    }

    [data-bs-theme="dark"] label {
        color: #e5e7eb;

        &:hover {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] h5 {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .c-pointer {
        color: #60a5fa;

        &:hover {
            color: #34d399;
        }
    }

    [data-bs-theme="dark"] :deep(.custom-popover) {
        background: #1e2330;
        border-color: rgba(96, 165, 250, 0.3);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);

        .popover-header {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        }

        .popover-body {
            background: #1e2330;
            color: #e5e7eb;
        }
    }

    [data-bs-theme="dark"] :deep(.input-group) {
        &:hover {
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.2);
        }
    }

    [data-bs-theme="dark"] :deep(.form-control) {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #f3f4f6;

        &:focus {
            background: #1a1d29;
            border-color: #60a5fa;
            box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.15);
        }
    }

    [data-bs-theme="dark"] :deep(.btn-primary) {
        background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        }
    }

    [data-bs-theme="dark"] .tyn-qa-message p,
    [data-bs-theme="dark"] .tyn-qa-message strong {
        color: inherit;
    }

    [data-bs-theme="dark"] span {
        color: #e5e7eb;
    }
</style>

